import Sortable from "sortablejs"

function initCartSortable() {
  document.querySelectorAll("[data-sortable-cart]").forEach((list) => {
    if (list.dataset.sortableInitialized) {
      return
    }

    list.dataset.sortableInitialized = "true"

    Sortable.create(list, {
      handle: ".order-line-item__drag-handle",
      draggable: ".order-line-item",
      animation: 150,
      ghostClass: "order-line-item--sortable-ghost",
      onEnd: async (evt) => {
        if (evt.oldDraggableIndex === evt.newDraggableIndex) {
          return
        }

        renumberBadges(list)

        const url = evt.item.dataset.updatePositionUrl
        if (!url) {
          return
        }

        const csrf = document.querySelector('meta[name="csrf-token"]')?.content

        try {
          const response = await fetch(url, {
            method: "PUT",
            headers: {
              "X-CSRF-Token": csrf,
              Accept: "application/json",
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({ position: evt.newDraggableIndex }),
          })
          if (!response.ok) throw new Error(`HTTP ${response.status}`)
        } catch (err) {
          window.location.reload()
        }
      },
    })
  })
}

function renumberBadges(list) {
  list.querySelectorAll(".order-line-item").forEach((item, index) => {
    item.querySelectorAll(".order-line-item__number > span").forEach((span) => {
      span.textContent = String(index + 1)
    })
  })
}

window.initCartSortable = initCartSortable
document.addEventListener("DOMContentLoaded", initCartSortable)
